import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BACKEND_URI } from "../config/config-vars";
import { firstValueFrom } from "rxjs";
import { BoardGameMeter } from "../models/boardGameMeter.model";

const BASE_URL = `${BACKEND_URI}/api/boardGameMeter`;

@Injectable({ providedIn: "root" })
export class BoardGameMeterService {
  constructor(private http: HttpClient) {}

  /**
   * Get all board game meter records by boardReadId (UUID)
   */
  async getByBoardReadId(boardReadId: string): Promise<BoardGameMeter[]> {
    try {
      const url = `${BASE_URL}?boardReadId=${encodeURIComponent(boardReadId)}`;
      return await firstValueFrom(this.http.get<BoardGameMeter[]>(url));
    } catch (error) {
      console.error("Failed to fetch board game meter data", error);
      return [];
    }
  }
}
